import { RoleModel } from '../../models/RoleModel';
import { ActionBase } from '../../../core/store/action/ActionBase';

export const REMOVE_ROLE_FROM_ROLE = '[Security] Role Remove Role';

export class RemoveRoleFromRoleAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = REMOVE_ROLE_FROM_ROLE;

  constructor(public payload: { roleKey: string, role: RoleModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/RemoveRoleFromRoleAction.ts